import { RATE_ROWS } from '../../../core/constants/kpis';
import { fmtNum, fmtPct } from '../utils/format';

// view=rates → rates{}. Barra horizontal por tasa; el COLOR lo dirige el
// `qualifier` del backend (good|regular|bad; null = operacional/neutro) — el UI
// nunca recalcula umbrales. Tasas tardías muestran cohort_n.

export default function RatesGrid({ rates }) {
    const data = rates || {};
    return (
        <article className="report-card report-rates">
            <h2 className="report-section__title">Tasas del proceso</h2>
            <div className="report-rates__grid">
                {RATE_ROWS.map((row) => {
                    const r = data[row.key] || {};
                    const value = Number(r.value) || 0;
                    const width = Math.max(0, Math.min(100, value));
                    return (
                        <div key={row.key} className="report-rate" data-qualifier={r.qualifier || 'none'}>
                            <div className="report-rate__head">
                                <span className="report-rate__label">{row.label}</span>
                                <span className="report-rate__value">{fmtPct(r.value)}</span>
                            </div>
                            <div className="report-rate__track">
                                <span className="report-rate__fill" style={{ width: `${width}%` }} />
                            </div>
                            <div className="report-rate__sub">
                                <span>{fmtNum(r.numerator)} / {fmtNum(r.denominator)}</span>
                                {row.late && r.cohort_n != null && <span>cohorte {fmtNum(r.cohort_n)}</span>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </article>
    );
}
